import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import BlockedUsersForm from '../components/BlockedUsersForm';
import { useCreateBlockedUser } from '../hooks/useBlockedUsersMutations';

export default function BlockedUsersCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreateBlockedUser();

  const handleSubmit = (data: any) => {
    mutation.mutate(data, {
      onSuccess: () => navigate('/blocked-users'),
    });
  };

  return (
    <div>
      <PageHeader back title={t('blockedUsers.createTitle')} subtitle={t('blockedUsers.createSubtitle')} />
      <Card>
        <BlockedUsersForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
